import React from "react";
import { DisplaySubmissionError } from "~/Brochure/SubmissionResult/DisplayHelpers";
import SubmissionResult from "~/Brochure/SubmissionResult/SubmissionResult";
import ErrorAlert from "~/common/Alert/ErrorAlert";
import Button from "~/common/Buttons";
import Input from "~/common/Form/Input";

interface Props {
  isSubmitting: boolean;
  submissionResponse: SubmissionResult | "GeneralFailure" | undefined;
}

export default function SubscriptionSignUpForm({
  isSubmitting,
  submissionResponse,
}: Props) {
  return (
    <div className="input-append subscription-box-email">
      <div className="flex flex-row justify-center -mb-6">
        <Input
          label="Email Address"
          name="EmailAddress"
          placeholder="Email address"
          labelClassName="h-0 m-0"
          className="rounded-r-none"
        />
        <Button
          type="submit"
          color="blue"
          size="small"
          className="rounded-l-none rounded-r-md px-4 py-2-1/2 h-[42px]"
          disabled={isSubmitting}
        >
          Add
        </Button>
      </div>
      {submissionResponse && (
        <ErrorAlert className="mb-6">
          {DisplaySubmissionError(submissionResponse)}
        </ErrorAlert>
      )}
    </div>
  );
}
